export enum AnalyticsSource {
  MyLists = 'my-lists',
  Spotlight = 'spotlight',
  Newsfeed = 'newsfeed',
  LookBook = 'lookbook',
}
